<template>
    <div class='sub-btn-wrap'>
        <div v-for='(item, index) in data' :key='index' class='sub-line'>
            <input v-model='item.rangeCount' class='w60 center' type='text' />
            <span class='txt'>
                <span v-if="type=='MT'">명</span>
                <span v-else>회</span> &nbsp;
                <span v-if='index + 1 < data.length'>이하</span>
                <span v-else class='red'>초과</span>
            </span>
            <input v-model='item.rangeValue' class='w220' type='text' />
            <span class='txt'>{{ type.charAt(1) == 'P' ? '%' : '원' }}</span>
        </div>
        <div class='btn-cnt'>
            <button class='com-btn blue' type='button' @click='add'>구간추가</button>
            <button :disabled='data.length <= 2' class='com-btn red' type='button' @click='remove'>구간삭제</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingEmployeeSalaryRange',
    props: {
        centerId: [Number, String],
        centerStaffId: [Number, String],
        settingHistorySeq: [Number, String],
        type: String,
        value: Array,
    },
    computed: {
        default() {
            const { centerId, centerStaffId, settingHistorySeq } = this.$props;
            return {
                centerId,
                centerStaffId,
                settingHistorySeq,
            };
        },
    },
    data() {
        return {
            rangeSeq: null,
            rangeHistorySeq: null,
            data: [],
        };
    },
    beforeMount() {
        this.data = this.value || [{ ...this.default }, { ...this.default }];
    },
    watch: {
        data: {
            deep: true,
            handler(v) {
                v.forEach(o => {
                    if (o.rangeCount < 0) o.rangeCount = 0;
                    if (o.rangeValue < 0) o.rangeValue = 0;
                    else if (this.type.charAt(1) == 'P' && o.rangeValue > 100) o.rangeValue = 100;
                });
                this.$emit('input', this.data);
            },
        },
    },
    methods: {
        add() {
            this.data.push({ ...this.default });
            this.$emit('input', this.data);
        },
        remove() {
            this.data.pop();
            this.$emit('input', this.data);
        },
    },
};
</script>
